import React, { useMemo } from 'react';
import { Filter, FilterSelection } from '../Filters.style';
import { BodyStyleFrame } from './bodyStyle.style';
import {
  BodyTypeFilterResultCounts,
  FilterOption,
  FilterResultCounts,
  RangeResultsCounts,
} from '../../../types';
import { ExposedFiltersTypes, FilterTypes } from '../../../constants/initialFilters';
import Body from './Body';
import FilterExposedHeader from '../FilterExposedHeader';
import useAnimations from '../../../hooks/Animations/useAnimations';
import { AvailableFiltersCount } from '../../../types/oneGraphTypes';

type BodyType = keyof BodyTypeFilterResultCounts;
interface BodyStyleTypes {
  filterType: string;
  bodyTypeOptions: AvailableFiltersCount[];
  confirmedFilters: FilterTypes;
  openedFiltersList: ExposedFiltersTypes;
  handleAddFilter: (filterType: string, value: string) => void;
  handleExposeFilter: (arg: string) => void;
}
const BodyStyle: React.FC<BodyStyleTypes> = ({
  filterType,
  bodyTypeOptions,
  confirmedFilters,
  openedFiltersList,
  handleAddFilter,
  handleExposeFilter,
}) => {
  const selectedBodyTypeLabels = confirmedFilters.bodyType;

  const showFilter = openedFiltersList[filterType];

  const { dropdownAnimation, filtersAccordianAnimation } = useAnimations(showFilter);

  return (
    <Filter>
      <FilterExposedHeader
        filterType={filterType}
        selectedFilterLabels={selectedBodyTypeLabels}
        handleExposeFilter={handleExposeFilter}
        openedFiltersList={openedFiltersList}
      />
      <>
        {dropdownAnimation(
          (props, item) =>
            item && (
              <FilterSelection style={props}>
                <BodyStyleFrame style={filtersAccordianAnimation}>
                  {bodyTypeOptions.map((body) => {
                    return (
                      <Body
                        key={body.id}
                        body={body}
                        filterType={filterType}
                        confirmedFilters={confirmedFilters}
                        handleAddFilter={handleAddFilter}
                      />
                    );
                  })}
                </BodyStyleFrame>
              </FilterSelection>
            ),
        )}
      </>
    </Filter>
  );
};

export default BodyStyle;
